import React from "react";

const defaultContext = {
  accounting: null,
  system: null,
  setSystem: () => {},
  SYSTEMS_NAME_MAP: {},
};

const AccountingContext = React.createContext(defaultContext);

AccountingContext.displayName = "Accounting Context";

export default AccountingContext;
